import { createRoute } from "@tanstack/react-router";
import { requirePermissions } from "@/app/guards";
import { ROLES_PERMISSIONS } from "@/app/nav";
import { RoleDetailPage } from "@/features/roles/RoleDetailPage";
import { RoleMatrix } from "@/features/roles/RoleMatrix";
import { staffRoute } from "@/routes/staff";

export const rolesRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "roles",
  beforeLoad: ({ context }) => requirePermissions(context.session, ROLES_PERMISSIONS),
  component: RoleMatrix,
});

export const roleDetailRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "roles/$roleId",
  beforeLoad: ({ context }) => requirePermissions(context.session, ROLES_PERMISSIONS),
  component: RoleDetailPage,
});
